import * as constants from './constants';

import { httpGet, httpPost } from '../../../global/http-utils';
import queryString from 'query-string';

export const getMetricsPromise = contactId => {
  return httpGet(constants.METRICS_PATH + queryString.stringify({ contactId: contactId }));
};

export const getLogsPromise = contactId => {
  return httpGet(constants.TIMBER_PATH + queryString.stringify({ contactId: contactId }));
};

export const getRtsDebugResponsePromise = (
  tenantId,
  text,
  sourceLocale,
  targetLocale,
  workflowSelectionAttributes,
  useBuild,
  overrideBranch,
  translationType,
  sessionId
) => {
  return httpPost(constants.RTS_PATH, {
    tenantId: tenantId,
    sourceText: text,
    sourceLocale: sourceLocale,
    targetLocale: targetLocale,
    workflowSelectionAttributes: workflowSelectionAttributes,
    useBuild: useBuild,
    overrideAbBranch: overrideBranch,
    translationType: translationType,
    sessionId: sessionId,
  });
};
